import {ReactComponent as Icon} from '@image/icon_btn_search.svg';

const IconBtnSearch = () => {
    return   <Icon />;
};

export default IconBtnSearch;